import { EditButton } from "@/components/button/SaveEditCancel/EditButton";
import styles from "./Permissions.module.css";
import { observer } from "mobx-react-lite";
import { userCurrentPanelState } from "@/stores/ComponentsState/UserCurrentPanelState";
import { userStore } from "@/stores/UserStore";
import { permissionsStore } from "@/stores/PermissionsStore";

export const Fio = observer(() => {
  const permission = permissionsStore.getPermissionsByRoleId(userStore.role!);

  return (
    <div className={styles.iterationPermissions}>
      <div className={styles.titleSection}>
        <span>ФИО:</span>
        <p suppressContentEditableWarning role-id={userStore.role}>
          {userStore.fio}
        </p>
        <EditButton
          disabled={!permission?.typePermissions.users.edit}
          onClick={() => userCurrentPanelState.handleEdit("fio", userStore.fio)}
        >
          Изменить
        </EditButton>
      </div>
    </div>
  );
});
